import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import IndeterminateCheckBoxOutlinedIcon from "@mui/icons-material/IndeterminateCheckBoxOutlined";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

const UICheckBox = ({
  label,
  checked,
  indeterminate,
  handleChange,
  labelPlacement = "end",
  size = "small",
  parentStyle = {},
  style = {},
  iconStyle = {
    color: "var(--palette-secondary_button_text)",
  },
  disabled = false,
  outlined = false,
}) => {
  return (
    <FormControlLabel
      disabled={disabled}
      sx={{
        ml: "0px",
        mr: "2px",
        fontSize: "5px",
        "& .MuiFormControlLabel-label": {
          color: "var(--palette-text)",
        },
        "& .Mui-disabled": {
          color: "var(--palette-disabled_button_text) !important",
        },
        ...parentStyle,
      }}
      control={
        <Checkbox
          indeterminate={indeterminate}
          checked={checked}
          icon={
            <CheckBoxOutlineBlankIcon
              style={{ color: "var(--palette-text)" }}
            />
          }
          onChange={handleChange}
          sx={{
            p: "5px",
            mr: 1,
            ...style,
          }}
          size={size}
          indeterminateIcon={
            <IndeterminateCheckBoxOutlinedIcon
              style={{ color: iconStyle.color }}
            />
          }
          checkedIcon={
            outlined && disabled ? (
              <CheckBoxIcon
                style={{
                  fill: "var(--palette-disabled_button_text)",
                }}
              />
            ) : (
              <CheckBoxIcon style={{ color: iconStyle.color }} />
            )
          }
        />
      }
      label={label}
      labelPlacement={labelPlacement}
    />
  );
};

export default UICheckBox;
